import React from 'react';
import {
  PDFViewer,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import logoJhimbo from '../images/logo-jhimbo.png';

const styles = StyleSheet.create({ //FALTAAAA
  page: {
    flexDirection: 'column',
    padding: 20,
    fontSize: 10,
    fontFamily: 'Helvetica',
    position: 'relative',
    bottom: '30'
  },

  // Encabezado principal
  headerContainer: {
    flexDirection: 'row',
    alignContent: 'center',
    paddingBottom: 10,
  },
  headerLeft: {
    flexDirection: 'column',
    width: '40%',
    lineHeight: 1.2,
    fontSize: 7,
  },
  logo: {
    width: 200,
    height: 60
  },
  titleBig: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 19,
    letterSpacing: 1,
    margin: 0,
    paddingLeft: 35,
    position: 'relative',
    top: '15',
    right: '50'
  },
  titleNumber: {
    fontSize: 18,
    color: '#ff3d3d',
    fontWeight: 'bold',
    paddingLeft: 70,
    letterSpacing: 2,
    fontFamily: 'Helvetica-Bold',
    position: 'relative',
    right: 10
  },

  // Sub-encabezado
  subHeaderContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingRight: '10',
    alignItems: 'center',
    position: 'relative',
    bottom: 10,
    fontSize: 9,
    marginTop: 5
  },

  //tabla
  tableContainer: {
    marginTop: 10,
    border: '1px solid #ddd',
    position: 'relative',
    bottom: 15
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#007bff',
    color: '#fff',
    padding: 8,
  },
  tableHeaderCell: {
    flex: 1,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 8,
  },
  tableHeaderCellDetalle: {
    flex: 1,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 8,

  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 6,
    borderBottom: '1px solid #ddd',
    flexWrap: 'wrap',
  },
  tableRowTotal: {
    flexDirection: 'row',
    paddingVertical: 6,
    borderBottom: '1px solid #ddd',
    flexWrap: 'wrap',
    backgroundColor: '#0468fb',
    color: '#fff'
  },
  tableCellSaldos: {
    flex: 1,
    textAlign: 'center',
    fontSize: 8,
    padding: 4
  },
  tableCell: {
    flex: 1,
    textAlign: 'center',
    fontSize: 8,
    paddingRight: 8,
    paddingLeft: 8
  },
  redText: {
    color: 'red',
  },
  orangeText: {
    color: 'orange',
  },
  greenText: {
    color: 'green',
  },
  blueText: {
    color: 'blue',
  },
  pinkText: {
    color: 'magenta',
  },

  tableSubHeader: {
    flexDirection: 'row',
    backgroundColor: '#007bff',
    color: '#fff',
    paddingVertical: 4,
    borderBottom: '1px solid #fff',
  },
  tableSubHeaderCell: {
    flex: 0.5,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 8,
    paddingRight: 11
  },
  totalTextOne: {
    fontWeight: 'bold',
    fontSize: 9,
    paddingRight: 50,
    position: 'relative',
    right: 10
  },
  totalTextTwo: {
    fontWeight: 'bold',
    fontSize: 9,
    paddingRight: 70
  },
  totalsFooter: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: 8,
    backgroundColor: '#007bff',
    color: '#fff',
  },

  //lineas finales firma
  signatureContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginTop: 20
  },
  signatureLine: {
    marginBottom: 5,
  },
  signatureBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }

});

const GenerateReporteCaja = () => {
  return <></>;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Encabezado */}
        <View style={styles.headerContainer}>
          <View style={styles.headerLeft}>
            <View style={{ position: 'relative', top: 7 }}>
              <Image src={logoJhimbo} style={styles.logo} />
            </View>
            <View>
              <Text>Empresa: Importada Maquinarias y Herramientas</Text>
              <Text>Dirección: 2do y 3er anillo Av. Virgen de Cotoca</Text>
              <View style={{ flexDirection: 'row', marginTop: '2px' }}>
                <Text>NIT: 11310247012 </Text>
                <Text style={{ paddingLeft: 15 }}>Tel: 67855168</Text>
              </View>
            </View>

          </View>
          <View style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Text style={styles.titleBig} >Reporte de Caja</Text>
          </View>
          <View style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Text style={styles.titleNumber}>N°65</Text>
          </View>
        </View>

        {/* Sub-encabezado */}
        <View style={styles.subHeaderContainer}>
          <Text>Caja: FERNANDO MENDOZA MAMANI  Tel: 65487562</Text>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '5', position: 'relative', bottom: 0 }}>
            <Text>Fecha: 20/10/2024</Text>
            <Text style={{ fontSize: 7, position: 'relative', top: '1.5' }}>23:50:00</Text>
          </View>

        </View>

        {/* Tabla 2 */}
        <View style={styles.tableContainer}>
          {/* Encabezado de la tabla */}
          <View style={styles.tableHeader}>
            <Text style={styles.tableHeaderCell}>FECHA</Text>
            <Text style={styles.tableHeaderCell}>CODIGO</Text>
            <Text style={styles.tableHeaderCell}>DETALLE</Text>
            <Text style={styles.tableHeaderCell}>P.C.</Text>
            <Text style={styles.tableHeaderCell}>B</Text>
            <Text style={styles.tableHeaderCell}>TOTAL</Text>
            <Text style={[styles.tableHeaderCell, { flex: 2 }]}>EFECTIVO</Text>
            <Text style={[styles.tableHeaderCell, { flex: 2 }]}>QR</Text>
            <Text style={styles.tableHeaderCell}>DEBO/E</Text>
          </View>
          <View style={styles.tableSubHeader}>
            <Text style={[styles.tableSubHeaderCell, { flex: 4 }]}></Text>
            <Text style={styles.tableSubHeaderCell}>Entrada</Text>
            <Text style={styles.tableSubHeaderCell}>Salida</Text>
            <Text style={styles.tableSubHeaderCell}>Entrada</Text>
            <Text style={styles.tableSubHeaderCell}>Salida</Text>
            <Text style={[styles.tableSubHeaderCell, { flex: 0.5 }]}></Text>
          </View>

          {/* Filas de datos */}
          <View style={styles.tableRow}>
            <Text style={styles.tableCell}>13/01/2025</Text>
            <Text style={styles.tableCell}>LT1900</Text>
            <Text style={styles.tableCell}>Generador de luz a gasolina 1Kw (LUTIAN)</Text>
            <Text style={styles.tableCell}>1150.00</Text>
            <Text style={styles.tableCell}>300.00</Text>
            <Text style={styles.tableCell}>1450.00</Text>
            <Text style={styles.tableCell}>0</Text>
            <Text style={styles.tableCell}>0</Text>
            <Text style={styles.tableCell}>0</Text>
            <Text style={styles.tableCell}>0</Text>
            <Text style={styles.tableCell}>-1450.00</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCell}>13/01/2025</Text>
            <Text style={styles.tableCell}>TOT-100LT</Text>
            <Text style={styles.tableCell}>Compresora de aire silenciosa 100lt</Text>
            <Text style={styles.tableCell}>5300.00</Text>
            <Text style={styles.tableCell}>200.00</Text>
            <Text style={styles.tableCell}>5500.00</Text>
            <Text style={styles.tableCell}>0</Text>
            <Text style={styles.tableCell}>0</Text>
            <Text style={styles.tableCell}>0</Text>
            <Text style={styles.tableCell}>0</Text>
            <Text style={styles.tableCell}>5500.00</Text>
          </View>

          {/* Totales finales */}
          <View style={styles.totalsFooter}>
            <Text style={styles.totalTextOne}>Total Ef: 0</Text>
            <Text style={styles.totalTextTwo}>Total Qr: 0</Text>
          </View>

        </View>





        {/* firma */}
        <View style={styles.signatureContainer}>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureLine}>___________________________</Text>
            <Text>Elmer Alvarez Alarcon</Text>
            <Text>Vendedor</Text>
          </View>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureLine}>___________________________</Text>
            <Text>Elmer Alvarez Alarcon</Text>
            <Text>Gerente General</Text>
          </View>
        </View>


      </Page>
    </Document>
  );
};

export default GenerateReporteCaja;
